import React, { useCallback } from 'react';

import ExercisePreviewContainer from '@ts-core/modules/exercises/components/ExercisePreviewContainer';
import QuestionsContainer from '@ts-core/modules/exercises/components/QuestionsContainer';

import { MultipleChoiceExercise, MultipleChoiceQuestion } from '../../types';

import MultipleChoiceQuestionInput from '../MultipleChoiceQuestionInput';

interface MultipleChoiceExerciseInputProps {
  exercise: MultipleChoiceExercise;
  loading?: boolean;

  onSelectOption: (option: any, questionId: string) => void;
  selectedOptions: Record<string, any>;
}

const MultipleChoiceExerciseInput = (props: MultipleChoiceExerciseInputProps) => {
  const { exercise, loading, selectedOptions, ...other } = props;

  const getSelectedOption = useCallback(
    (question?: MultipleChoiceQuestion): string | undefined => {
      if (!question) {
        return undefined;
      }
      return selectedOptions[question._id] as string;
    },
    [selectedOptions]
  );

  return (
    <ExercisePreviewContainer exercise={exercise} loading={loading}>
      <QuestionsContainer
        questions={exercise.questions}
        loading={loading}
        renderQuestion={(index, question) => (
          <MultipleChoiceQuestionInput
            key={question?._id || index}
            question={question}
            loading={loading}
            getSelectedOption={getSelectedOption}
            {...other}
          />
        )}
      />
    </ExercisePreviewContainer>
  );
};

export default MultipleChoiceExerciseInput;
